import { Sidebar, SidebarContent } from "@elit-hair/elit-ui";

export function SidebarRight() {
  return (
    <Sidebar side="right" variant="inset" collapsible="offcanvas">
      <SidebarContent className="pr-2 h-full overflow-hidden"></SidebarContent>
    </Sidebar>
  );
}
